import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { PAGE_PROPS } from "../constants/common";
import { ISearchAPIPayload } from "../types/common";
import { IMPOSED_FINES_INITIAL_STATE } from "../constants/imposedFines.constants";

export const getAllPagedImposedFines = createAsyncThunk(
  "imposedFines/getAllPaged",
  async (data: ISearchAPIPayload) => {
    const response = await axios.post("/api/Fine/SearchPagedFines", data);
    return response.data;
  }
);

export const getImposedFineByRefNo = createAsyncThunk(
  "imposedFines/getImposedFineByRefNo",
  async (referenceCode: string) => {
    const response = await axios.get(
      "/api/Fine/GetFineByReferenceCode/" + referenceCode
    );
    return response.data;
  }
);

export const imposedFinesSlice = createSlice({
  name: "imposedFines",
  initialState: IMPOSED_FINES_INITIAL_STATE,
  reducers: {
    onChangeImposedFinesList: (state, action) => {
      state.pageProps = action.payload;
    },
    clearSearchFine: (state) => {
      state.searchFine = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPagedImposedFines.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPagedImposedFines.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.result ?? PAGE_PROPS;
        state.error = null;
      })
      .addCase(getAllPagedImposedFines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getImposedFineByRefNo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getImposedFineByRefNo.fulfilled, (state, action) => {
        state.loading = false;
        state.searchFine = action.payload?.result ?? PAGE_PROPS;
        state.error = null;
      })
      .addCase(getImposedFineByRefNo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const { onChangeImposedFinesList, clearSearchFine } =
  imposedFinesSlice.actions;

export default imposedFinesSlice.reducer;
